import { render } from "./Time.vue?vue&type=template&id=bb5c625c&scoped=true"
import script from "./Time.vue?vue&type=script&lang=js"
export * from "./Time.vue?vue&type=script&lang=js"

import "./Time.vue?vue&type=style&index=0&id=bb5c625c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb5c625c"]])

export default __exports__